import { Navigate, useLocation } from "react-router-dom";
import { useProjectContext } from "../context";
import { useWorkspaceContext } from "@core/context";
import { ALL_PROJECT_NAV_ITEMS } from "../config";

type ProjectRouteGuardProps = {
  children: React.ReactNode;
};

export function ProjectRouteGuard({ children }: ProjectRouteGuardProps) {
  const { role, projectId } = useProjectContext();
  const { workspaceId } = useWorkspaceContext();
  const { pathname } = useLocation();

  const segments = pathname.split("/").filter(Boolean);

  // Match the deepest nav item whose path appears in the current URL.
  // Nested routes (e.g. team/members, team/groups) resolve via the
  // parent segment ("team"), so we check membership rather than the
  // trailing segment alone.
  const navItem = ALL_PROJECT_NAV_ITEMS.find((item) =>
    segments.includes(item.path),
  );

  if (navItem && !navItem.roles.includes(role)) {
    return (
      <Navigate
        to={`/workspace/${workspaceId}/project-portal/${projectId}/team`}
        replace
      />
    );
  }

  return <>{children}</>;
}
